import TestPage from '@/pages/srilanka/TestPage.vue';
import SubjectPhotos from '@/pages/srilanka/SubjectPhotos.vue';
import PublicDocuments from '@/pages/unitaid/uploads/srilanka/PublicDocuments.vue';
import Uploads from '@/pages/unitaid/uploads/srilanka/Upload.vue';
import Dashboard from '../pages/dashboard/srilanka/Dashboard.vue';
import SeriousAdverseEvents from '../pages/unitaid/adverse-events/srilanka/SeriousAdverseEventsTable.vue';
import Analysis from '@/pages/unitaid/analysis/srilanka/Analysis.vue'
// EntoData
import CollectionCodeLookup from '@/pages/unitaid/ento-data-entry/srilanka/CollectionCodeLookup.vue';
import MosquitoDataEntry from '@/pages/unitaid/ento-data-entry/srilanka/MosquitoDataEntry.vue';
import ProcessNewCollection from '@/pages/unitaid/ento-data-entry/srilanka/ProcessNewCollection.vue';
// Blood Sample Processing:
import BloodSampleReceiving from '@/pages/unitaid/blood-sample/srilanka/BloodSampleReceiving.vue';
import IggElisaProcessing from '@/pages/unitaid/blood-sample/srilanka/IggElisaProcessing.vue';
import IgmElisaProcessing from '@/pages/unitaid/blood-sample/srilanka/IgmElisaProcessing.vue';
import IElisaProcessing from '@/pages/unitaid/blood-sample/srilanka/IElisaProcessing.vue';
import FrntProcessing from '@/pages/unitaid/blood-sample/srilanka/FrntProcessing.vue';
import RtpcrProcessing from '@/pages/unitaid/blood-sample/srilanka/RtpcrProcessing.vue';
import BloodSampleReview from '@/pages/unitaid/blood-sample/srilanka/BloodSampleReview.vue';
import BloodSampleEdit from '@/pages/unitaid/blood-sample/srilanka/BloodSampleEdit.vue';
// Product Bag Utilities:
import ProductBagPreparation from '@/pages/srilanka/product-bag-utilities/ProductBagPreparation.vue';
import ProductBagReceiving from '@/pages/srilanka/product-bag-utilities/ProductBagReceiving.vue';
import ProductBagSummary from '@/pages/srilanka/product-bag-utilities/ProductBagSummary.vue';
import ProductBagEdit from '@/pages/srilanka/product-bag-utilities/ProductBagEdit.vue';
// Metrics:
import SubjectEnrollment from '@/pages/unitaid/subject-enrollment/srilanka/SubjectEnrollment.vue'
import TipsData from '../pages/srilanka/social-sciences/TipsData.vue'
import Generic from '../pages/srilanka/data-viewers/Generic.vue'
import RandomSubjects from '../pages/srilanka/subject-enrollment/RandomSubjects.vue';
// Subject Final Status:
import NewSubjectFollowup from '../pages/unitaid/subject-final-status/srilanka/NewSubjectFollowup.vue';
// Product Replacements
import ProductReplacementTable from '../pages/srilanka/products/ProductReplacementTable.vue';
// IgG ELISA
import UploadIgGELISA from '@/pages/unitaid/blood-sample/srilanka/UploadIgGELISA.vue';
// Luminex
import UploadLuminex from '@/pages/unitaid/blood-sample/srilanka/UploadLuminex.vue';
// Luminex IGM (Final Luminx Testing)
import UploadLuminexIGM from '@/pages/unitaid/blood-sample/srilanka/UploadLuminexIGM.vue';
// Febrile Withdrawal
import FebrileWithdrawalRequestTables from '@/pages/srilanka/withdrawal-requests/FebrileWithdrawalRequestTables.vue';
// Longitudinal Withdrawal
import LongitudinalWithdrawalRequestTables from '@/pages/srilanka/withdrawal-requests/LongitudinalWithdrawalRequestTables.vue';
// Product Withdrawal
import ProductWithdrawalRequestTables from '@/pages/srilanka/withdrawal-requests/ProductWithdrawalRequestTables.vue';
// Ento Withdrawal: not ready yet
import EntoWithdrawalRequestTables from '@/pages/srilanka/withdrawal-requests/EntoWithdrawalRequestTables.vue';
// Summary Slide Report
import SummarySlideReport from '@/pages/unitaid/analysis/srilanka/SummarySlideReport.vue';
// SR Coverage Indicators Report
import SRCoverageIndicatorsReport from '@/pages/unitaid/analysis/srilanka/SRCoverageIndicatorsReport.vue';

const srilankaRoutes = [
  {
    path: '',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: 'product-bag-preparation',
    name: 'product-bag-preparation',
    component: ProductBagPreparation
  },
  {
    path: 'product-bag-receiving',
    name: 'product-bag-receiving',
    component: ProductBagReceiving
  },
  {
    path: 'product-bag-summary',
    name: 'product-bag-summary',
    component: ProductBagSummary
  },
  {
    path: 'product-bag-edit/:id',
    name: 'product-bag-edit',
    component: ProductBagEdit,
    props: true,
  },
  {
    path: 'public-documents',
    name: 'public-documents',
    component: PublicDocuments
  },
  {
    path: 'serious-adverse-events',
    name: 'serious-adverse-events',
    component: SeriousAdverseEvents
  },
  {
    path: 'subject-final-status',
    name: 'subject-final-status',
    component: NewSubjectFollowup,
  },
  {
    path: 'uploads',
    name: 'uploads',
    component: Uploads
  },
  {
    path: 'subject-photos',
    name: 'subject-photos',
    component: SubjectPhotos
  },
  {
    path: 'analysis',
    name: 'analysis',
    component: Analysis
  },
  {
    path: 'ento/collection-code-lookup',
    name: 'collection-code-lookup',
    component: CollectionCodeLookup,
  },
  {
    path: 'ento/mosquito-data-entry',
    name: 'mosquito-data-entry',
    component: MosquitoDataEntry,
  },
  {
    path: 'ento/new-collection',
    name: 'new-collection',
    component: ProcessNewCollection,
  },
  {
    path: 'blood-sample-receiving',
    name: 'blood-sample-receiving',
    component: BloodSampleReceiving
  },
  {
    path: 'igg-elisa-processing',
    name: 'igg-elisa-processing',
    component: IggElisaProcessing
  },
  {
    path: 'ielisa-processing',
    name: 'ielisa-processing',
    component: IElisaProcessing
  },
  {
    path: 'frnt-processing',
    name: 'frnt-processing',
    component: FrntProcessing
  },
  {
    path: 'rtpcr-processing',
    name: 'rtpcr-processing',
    component: RtpcrProcessing
  },
  {
    path: 'igm-elisa-processing',
    name: 'igm-elisa-processing',
    component: IgmElisaProcessing
  },
  {
    path: 'blood-sample-review',
    name: 'blood-sample-review',
    component: BloodSampleReview
  },
  {
    path: 'blood-sample-edit/:id',
    name: 'blood-sample-edit',
    component: BloodSampleEdit,
    props: true,
  },
  {
    path: 'metrics/subject-enrollment',
    name: 'metrics-subject-enrollment',
    component: SubjectEnrollment
  },
  {
    path: 'test',
    name: 'test',
    component: TestPage
  },
  {
    path: 'tips-data',
    name: 'tips-data',
    component: TipsData
  },
  // this is for Retail Audit Listing Data
  {
    path: 'data-viewers/generic',
    name: 'generic',
    component: Generic,
  },
  // Random subject
  {
    path: 'random-subjects',
    name: 'random-subjects',
    component: RandomSubjects,
  },
  // creat new route for Retail Audit Study Data even if it uses the same component with Retail Audit Listing Data
  {
    path: 'data-viewers/generic-retail-study',
    name: 'generic-retail-study',
    component: Generic,
  },
  {
    path: 'product-replacements',
    name: 'product-replacements',
    component: ProductReplacementTable
  },
  // IgG ELISA
  {
    path: 'upload-igg-elisa',
    name: 'upload-igg-elisa',
    component: UploadIgGELISA
  },
  // Luminex
  {
    path: 'upload-luminex',
    name: 'upload-luminex',
    component: UploadLuminex
  },
  // Luminex IGM ( Final Luminex Testing )
  {
    path: 'upload-luminex-igm',
    name: 'upload-luminex-igm',
    component: UploadLuminexIGM
  },
  // Febrile Withdrawal Request
  {
    path: 'febrile-withdrawal-request',
    name: 'febrile-withdrawal-request',
    component: FebrileWithdrawalRequestTables,
  },
  // Longitudinal Withdrawal Request
  {
    path: 'longitudinal-withdrawal-request',
    name: 'longitudinal-withdrawal-request',
    component: LongitudinalWithdrawalRequestTables,
  },
  // Product Withdrawal Request
  {
    path: 'product-withdrawal-request',
    name: 'product-withdrawal-request',
    component: ProductWithdrawalRequestTables,
  },
  // Ento Withdrawal: not ready yet
  {
    path: 'ento-withdrawal-request',
    name: 'ento-withdrawal-request',
    component: EntoWithdrawalRequestTables,
  },
  // Summary Slide Report
  {
    path: 'summary-slide-report',
    name: 'summary-slide-report',
    component: SummarySlideReport
  },
  // SR Coverage Indicators Report
  {
    path: 'sr-coverage-indicators-report',
    name: 'sr-coverage-indicators-report',
    component: SRCoverageIndicatorsReport
  },
];

export { srilankaRoutes }